import { useContract } from './useContract'
import useEnvConfig from 'hooks/useEnvConfig'
import { ABI_COCOS_BLINDBOX } from '../utils/abis'
import { useCallback, useEffect, useState } from 'react'
import { useWeb3React } from '@web3-react/core'
import { DialogType, useDialog } from '../context/DialogContext'

export function useBlindBoxApproved(spender: string, silence: boolean = true) {
  const envConfig = useEnvConfig()
  const contract = useContract(envConfig.ADDRESS_COCOS_BLINDBOXNFT, ABI_COCOS_BLINDBOX)
  const { account } = useWeb3React()
  const [approved, setApproved] = useState(false)
  const { open } = useDialog()
  const [loading, setLoading] = useState(false)
  useEffect(() => {
    setApproved(false)
  }, [account, spender])
  useEffect(() => {
    if (contract) {
      contract.isApprovedForAll(account, spender).then(setApproved)
    }
  }, [contract, account, spender])
  const approve = useCallback(async () => {
    if (contract) {
      setLoading(true)
      try {
        !silence && open(DialogType.Waiting, { title: 'Waiting for approve!' })
        const operation = await contract.setApprovalForAll(spender, true)
        !silence && open(DialogType.Waiting, { title: 'Waiting for confirmation.' })
        const res = await operation.wait()
        setApproved(true)
        return res
      } catch (e:any) {
        console.log(e)
        !silence &&
          open(DialogType.Error, { title: 'Approve failed!', desc: e.message || e.data.message || 'unknown error!' })
        throw new Error('error approved')
      } finally {
        setLoading(false)
      }
    }
  }, [contract, spender, silence, open])
  return { approved, approve, loading }
}
